import { call, put, takeLatest } from "redux-saga/effects";

import {
  EnvironmentState,
  environmentStateActions,
} from "store/slices/environment/slice";
import { environmentActions } from "./environment.action";
import { getEnvironment } from "./environment.api";

function* initEnvironmentSaga() {
  const environment: EnvironmentState = yield call(getEnvironment);
  yield put(environmentStateActions.setEnvironment(environment));
}

export default function* environmentSaga() {
  yield takeLatest(environmentActions.initEnvironment, initEnvironmentSaga);
}
